import { TLBounds, TLShape, Utils } from "@tldraw/core";

/**
 * Find the bounds of a rectangular shape.
 * @param shape
 * @param boundsCache
 */
export function getBoundsRectangle<T extends TLShape & { props: { size: number[]; point: number[] }; point: number[] }>(
  shape: T,
  boundsCache: WeakMap<T, TLBounds>
) {
  const bounds = Utils.getFromCache(boundsCache, shape, () => {
    const [width, height] = shape.props.size;
    console.log(shape);
    return {
      minX: 0,
      maxX: width,
      minY: 0,
      maxY: height,
      width,
      height,
    };
  });

  return Utils.translateBounds(bounds, shape.props.point);
}
